<template>
  <v-dialog v-model="addDialog" class="the-app-dialogs" persistent max-width="800px">
    <v-card>
      <form @submit.prevent="validateBeforeSubmit($event)">
        <v-layout row class="no-select" style="background-color:#09132f">
          <h3 id="dialog-title" class="text-uppercase px-3 pt-3" style="text-xs-center letter-spacing:2px">
            <v-layout align-center>
              <v-icon light x-large class="rgba(0,0,0,0.3)--text pb-1">fa-user-friends</v-icon>
              <span class="px-3">{{ $t('Add New Supplier') }}</span>
            </v-layout>
          </h3>
          <v-spacer />
          <v-card-actions>
            <v-btn fab icon dark @click="$emit('hidemodal')">
              <v-icon>close</v-icon>
            </v-btn>
          </v-card-actions>
        </v-layout>

        <v-card-title class="grey lighten-3">
          <v-layout row wrap>
            <v-flex xs12 sm8 class="pa-2">
              <v-text-field
                id="supplier-focus-me"
                v-model="form.theName"
                :label="`${$t('Supplier Name')} *`"
                name="vender_name"
                box
                hide-details
                background-color="white"
                :error="errors.has('vender_name')"
                v-validate="'required'"
              />
            </v-flex>

            <v-flex xs12 sm4 class="pa-2">
              <v-autocomplete
                v-model="form.theType"
                :items="supplierTypeList"
                :label="`${$t('Type')}`"
                box
                hide-details
                background-color="white"
                :error="errors.has('individual or company')"
                data-vv-name="individual or company"
                :menu-props="{ transition: 'slide-y-transition' }"
              />
            </v-flex>

            <v-flex xs12 sm4 class="pa-2">
              <v-text-field
                v-model="form.thePhone"
                :label="$t('Phone')"
                name="vender_phone"
                box
                hide-details
                background-color="white"
                :error="errors.has('vender_phone')"
              />
            </v-flex>

            <v-flex xs12 sm8 class="pa-2">
              <v-text-field
                v-model="form.theEmail"
                :label="$t('Email')"
                name="vender_mail"
                box
                hide-details
                background-color="white"
                autocomplete="off"
                :error="errors.has('vender_mail')"
                v-validate="'email'"
                data-vv-validate-on="blur"
              />
            </v-flex>

            <v-flex xs12 sm4 class="pa-2">
              <v-autocomplete
                v-model="form.theCountry"
                :items="countriesList"
                :label="`${$t('Country')}`"
                box
                hide-details
                browser-autocomplete
                background-color="white"
                :menu-props="{ transition: 'slide-y-transition' }"
              />
            </v-flex>

            <v-flex xs12 sm4 class="pa-2">
              <v-text-field
                v-model="form.theGovernorate"
                :label="$t('Governorate')"
                name="vender_governorate"
                box
                hide-details
                background-color="white"
                autocomplete="off"
                :error="errors.has('vender_governorate')"
              />
            </v-flex>

            <v-flex xs12 sm4 class="pa-2">
              <v-text-field
                v-model="form.theCity"
                :label="$t('City')"
                name="vender_city"
                box
                hide-details
                background-color="white"
                autocomplete="off"
                :error="errors.has('vender_city')"
              />
            </v-flex>

            <v-flex xs12 class="pa-2">
              <v-textarea
                v-model="form.theAddress"
                :label="$t('Address')"
                name="vender_address"
                box
                hide-details
                height="80"
                background-color="white"
                :error="errors.has('vender_address')"
              />
            </v-flex>
          </v-layout>
        </v-card-title>
        <v-divider light />

        <v-card-actions class="grey lighten-3">
          <v-layout column>
            <v-flex xs12 class="pb-2 px-2" style="color: #444;"
              >- {{ $t('Fields marked with asterisk ( * ) are required.') }}</v-flex
            >

            <v-layout justify-end align-center pr-2 pl-2>
              <v-checkbox color="primary" v-model="keepForm" :label="$t('Keep this form to add another one.')" />

              <v-btn outline color="primary" @click="$emit('hidemodal')">{{ $t('Cancel') }}</v-btn>
              <v-btn type="submit" color="success" :loading="btnAddLoading">
                <v-icon :right="$vuetify.rtl" :left="!$vuetify.rtl">save</v-icon>
                {{ $t('Add') }}
              </v-btn>
            </v-layout>
          </v-layout>
        </v-card-actions>
      </form>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'add-component',

  props: {
    addDialog: { type: Boolean, required: true }
  },

  data() {
    return {
      btnAddLoading: false,
      form: {
        theName: null,
        theType: null,
        thePhone: null,
        theEmail: null,
        theCountry: null,
        theGovernorate: null,
        theCity: null,
        theAddress: null
      },
      keepForm: false
    }
  },

  computed: {
    ...mapGetters({
      supplierTypeList: 'suppliers/getSupplierTypeList',
      countriesList: 'locale/getCountriesList'
    })
  },

  watch: {
    addDialog: {
      immediate: false,
      handler() {
        if (this.addDialog) {
          this.addEscKeyListener()
          this.resetForm()
          this.keepForm = false
        }
      }
    }
  },

  methods: {
    ...mapActions({
      addSupplier: 'suppliers/addSupplier'
    }),

    addEscKeyListener() {
      document.addEventListener('keyup', e => {
        // if the "ESC" button was pressed and this dialog is shown, hide it
        if (e.keyCode === 27 && this.addDialog) {
          this.$emit('hidemodal')
        }
      })
    },

    resetForm() {
      this.$validator.pause()
      for (let key in this.form) {
        this.form[`${key}`] = null
      }
      this.$nextTick(() => {
        this.$validator.resume()
        // default veutify autofocus only one time works so we have to handled in this way.
        // document.getElementById('supplier-focus-me').focus()
      })
    },

    validateBeforeSubmit(event) {
      this.$validator
        .validateAll()
        .then(() => {
          if (!this.errors.any()) {
            this.btnAddLoading = true

            let formData = new FormData(event.target)
            formData.append('individual_or_company', this.form.theType || '')
            formData.append('vender_country', this.form.theCountry || '')

            // for (let pair of formData.entries()) {
            //   console.warn(`${pair[0]}: ${pair[1]}`)
            // }

            this.addSupplier(formData)
              .then(() => {
                this.btnAddLoading = false
                this.$emit('reset-datatable')
                if (this.keepForm) {
                  this.resetForm()
                } else {
                  this.$emit('hidemodal')
                }
              })
              .catch(() => {
                this.btnAddLoading = false
              })
          }
        })
        .catch(() => {
          this.btnAddLoading = false
        })
    }
  }
}
</script>

<style scoped />
